import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb7ac7ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "dt-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Compare Plans", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 px-0" }
const _hoisted_9 = { class: "dt-container--small d-flex align-items-center flex-wrap flex-md-nowrap" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-0 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "dt-tag glare me-2" }, "New"),
    /*#__PURE__*/_createTextVNode("Ditto Onboarding")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "Learn how Ditto works and set up your account in minutes.")
], -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "dt-container--small d-flex flex-column" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ditto Receivers", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "This is the number of active receivers in your account.", -1))
const _hoisted_17 = { class: "mt-3 d-flex flex-column align-items-start" }
const _hoisted_18 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "dt-container--small d-flex flex-column" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "My Account", -1))
const _hoisted_22 = { class: "m-0" }
const _hoisted_23 = { class: "my-3 overflow-auto" }
const _hoisted_24 = {
  class: "w-100",
  style: {"font-size":"0.9rem"}
}
const _hoisted_25 = { class: "m-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold ps-2",
  style: {"min-width":"100px"}
}, "Account status", -1))
const _hoisted_27 = { class: "m-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold ps-2" }, "Current plan", -1))
const _hoisted_29 = { class: "m-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold ps-2" }, "Users", -1))
const _hoisted_31 = { class: "m-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold ps-2" }, "Receivers", -1))
const _hoisted_33 = { class: "m-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold ps-2" }, "Storage", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("em", null, "A receiver is active when it's linked to a Ditto room.")
], -1))
const _hoisted_36 = { class: "mt-3 d-flex flex-column align-items-start" }
const _hoisted_37 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_38 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_39 = { class: "mb-4" }
const _hoisted_40 = { class: "dt-container--small" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ditto Setup Guide", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "Learn how to get started with Ditto.", -1))
const _hoisted_43 = { class: "mt-2 mb-3" }
const _hoisted_44 = {
  href: "https://help.airsquirrels.com/ditto/80-ditto-setup-guide",
  target: "_blank",
  rel: "noreferrer noopener"
}
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "mb-4" }
const _hoisted_48 = { class: "dt-container--small" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Troubleshooting Ditto", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "Get help with Ditto.", -1))
const _hoisted_51 = { class: "mt-2 mb-3" }
const _hoisted_52 = { class: "mb-2" }
const _hoisted_53 = {
  href: "https://help.airsquirrels.com/ditto",
  target: "_blank",
  rel: "noreferrer noopener"
}
const _hoisted_54 = {
  href: "https://help.airsquirrels.com/ditto/kb-tickets/new",
  target: "_blank",
  rel: "noreferrer noopener"
}
const _hoisted_55 = { class: "text-center" }
const _hoisted_56 = ["src"]
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "mb-4" }
const _hoisted_59 = { class: "dt-container--small" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": Reports display example data during trials.")
], -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { class: "mb-4" }
const _hoisted_64 = { class: "dt-container--small" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": Reports display example data during trials.")
], -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { key: 2 }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-md-6 p-md-0 pe-md-3" }
const _hoisted_71 = { class: "dt-container--small d-flex flex-column" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ditto Receivers", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "This is the number of active receivers in your account.", -1))
const _hoisted_74 = {
  key: 0,
  class: "mt-3 d-flex flex-column align-items-start"
}
const _hoisted_75 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_76 = {
  key: 1,
  class: "mt-3 mt-md-2 d-sm-flex align-items-center flex-grow-1"
}
const _hoisted_77 = {
  key: 1,
  class: "ms-sm-2 mt-2 mt-sm-0 mb-0"
}
const _hoisted_78 = { class: "col-md-6 p-md-0 ps-md-3 mt-4 mt-md-0" }
const _hoisted_79 = { class: "dt-container--small d-flex flex-column" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "My Account", -1))
const _hoisted_81 = { class: "m-0" }
const _hoisted_82 = {
  key: 0,
  class: "my-3 overflow-auto"
}
const _hoisted_83 = {
  class: "w-100",
  style: {"font-size":"0.9rem"}
}
const _hoisted_84 = { class: "m-2" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold ps-2",
  style: {"min-width":"120px"}
}, "Account status", -1))
const _hoisted_86 = { class: "m-2" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold ps-2" }, "Current plan", -1))
const _hoisted_88 = { class: "m-2" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold ps-2" }, "Users", -1))
const _hoisted_90 = { class: "m-2" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold ps-2" }, "Receivers", -1))
const _hoisted_92 = { class: "m-2" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold ps-2" }, "Storage", -1))
const _hoisted_94 = {
  key: 1,
  class: "my-3"
}
const _hoisted_95 = { class: "m-2" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold w-25 ps-2" }, "Account status", -1))
const _hoisted_97 = { class: "w-25" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold w-25" }, "Current plan", -1))
const _hoisted_99 = { class: "w-25" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_101 = { class: "m-2" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold w-25 ps-2" }, "Users", -1))
const _hoisted_103 = { class: "w-25" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold w-25" }, "Storage", -1))
const _hoisted_105 = { class: "w-25" }
const _hoisted_106 = { class: "m-2" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold w-25 ps-2" }, "Receivers", -1))
const _hoisted_108 = { class: "w-25" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bold w-25" }, null, -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25" }, null, -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("em", null, "A receiver is active when it's linked to a Ditto room.")
], -1))
const _hoisted_112 = {
  key: 2,
  class: "mt-3 d-flex flex-column align-items-start"
}
const _hoisted_113 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_114 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_115 = {
  key: 3,
  class: "mt-3 d-sm-flex align-items-center flex-grow-1"
}
const _hoisted_116 = {
  key: 1,
  class: "ms-sm-2 mt-2 mt-sm-0 mb-0"
}
const _hoisted_117 = {
  key: 2,
  class: "ms-sm-2 mt-2 mt-sm-0 mb-0"
}
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-md-6 p-md-0 pe-md-3" }
const _hoisted_120 = { class: "dt-container--small d-sm-flex justify-content-between align-items-center" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ditto Setup Guide", -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "Learn how to get started with Ditto.", -1))
const _hoisted_123 = { class: "mt-2" }
const _hoisted_124 = {
  href: "https://help.airsquirrels.com/ditto/80-ditto-setup-guide",
  target: "_blank",
  rel: "noreferrer noopener"
}
const _hoisted_125 = ["src"]
const _hoisted_126 = { class: "col-md-6 p-md-0 ps-md-3 mt-4 mt-md-0" }
const _hoisted_127 = { class: "dt-container--small d-sm-flex justify-content-between align-items-center" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Troubleshooting Ditto", -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "Get help with Ditto.", -1))
const _hoisted_130 = { class: "mt-2" }
const _hoisted_131 = {
  href: "https://help.airsquirrels.com/ditto",
  target: "_blank",
  rel: "noreferrer noopener",
  class: "me-2"
}
const _hoisted_132 = { class: "mt-2" }
const _hoisted_133 = {
  href: "https://help.airsquirrels.com/ditto/kb-tickets/new",
  target: "_blank",
  rel: "noreferrer noopener"
}
const _hoisted_134 = ["src"]
const _hoisted_135 = {
  key: 0,
  class: "row"
}
const _hoisted_136 = { class: "col-md-6 p-md-0 pe-md-3" }
const _hoisted_137 = { class: "dt-container--small" }
const _hoisted_138 = { key: 0 }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": Reports display example data during trials.")
], -1))
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = { class: "col-md-6 p-md-0 ps-md-3 mt-4 mt-md-0" }
const _hoisted_142 = { class: "dt-container--small" }
const _hoisted_143 = { key: 0 }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": Reports display example data during trials.")
], -1))
const _hoisted_145 = [
  _hoisted_144
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_compare_plans = _resolveComponent("compare-plans")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_SubscriptionStatusProgress = _resolveComponent("SubscriptionStatusProgress")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UsageStatBarGraph = _resolveComponent("UsageStatBarGraph")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_ctx.me && _ctx.me.superUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, [
            _createTextVNode("Welcome, "),
            (_ctx.me)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.me.name), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_compare_plans, {
              subscriptionPlan: null,
              showTrial: true
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, [
            _createTextVNode("Welcome, "),
            (_ctx.me)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.me.organization.name), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.userOnboardStatus.value.isOnboarding && !_ctx.hideOnboardingOnMobile.value && !_ctx.hideOnboardingByAccess.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          class: "onboarding-icon me-4",
                          alt: "Ditto Portal Onboarding",
                          src: require('../../assets/images/onboarding.png')
                        }, null, 8, _hoisted_10),
                        _hoisted_11,
                        _createVNode(_component_el_button, {
                          class: "glare mt-4 mt-md-0 ms-md-4",
                          type: "primary",
                          onClick: _ctx.onStartOnboarding
                        }, {
                          default: _withCtx(() => [
                            (_ctx.userOnboardStatus.value.step > 1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Finish ")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Start ")
                                ], 64)),
                            _createTextVNode(" Setup ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_divider)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.windowWidth.value < 576)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _hoisted_16,
                      _createVNode(_component_SubscriptionStatusProgress, {
                        dashboardMode: true,
                        class: "subscription-status flex-grow-1"
                      }),
                      _createElementVNode("div", _hoisted_17, [
                        (_ctx.isSystemRole)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push({ path: '/receivers/' }))),
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Add Receivers")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.isTrial)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.subscriptionStatus ? _ctx.subscriptionStatus.subscriptionAvailability : 0) + " subscribed receiver" + _toDisplayString(_ctx.subscriptionStatus && _ctx.subscriptionStatus.subscriptionAvailability == 1 ? "" : "s"), 1),
                              _createTextVNode(" remaining")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.isTrial ? "Your trial is active. Use Ditto free for 30 days." : "Your account is active and paid."), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("table", _hoisted_24, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("td", null, _toDisplayString(_ctx.accountStatus) + " " + _toDisplayString(!_ctx.isTrial ? "Billing" : ""), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_27, [
                              _hoisted_28,
                              _createElementVNode("td", null, _toDisplayString(_ctx.tierName), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("td", null, _toDisplayString(_ctx.orgUserUsage), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("td", null, _toDisplayString(_ctx.orgReceiverUsage), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_33, [
                              _hoisted_34,
                              _createElementVNode("td", null, _toDisplayString(_ctx.orgStorageUsage), 1)
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, [
                        (_ctx.hasBillingAccess)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: '/organization/billing',
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Go to Billing")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.isTrial && _ctx.isSubscriptionActive)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                              _createTextVNode("Your subscription renews on "),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.renewalDate), 1)
                            ]))
                          : (_ctx.isSubscriptionActive)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                                _createTextVNode("Your trial expires on "),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.expirationDate), 1)
                              ]))
                            : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", null, [
                        _hoisted_41,
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("a", _hoisted_44, [
                            _createVNode(_component_el_button, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Learn More")
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("img", {
                          class: "dashboard-help-image",
                          src: require('../../assets/images/customization.png'),
                          alt: "",
                          style: {"max-width":"100%","height":"auto"}
                        }, null, 8, _hoisted_46)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", null, [
                        _hoisted_49,
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("a", _hoisted_53, [
                              _createVNode(_component_el_button, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("See All Topics")
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("a", _hoisted_54, [
                              _createVNode(_component_el_button, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Open Support Ticket")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("img", {
                          class: "dashboard-help-image",
                          src: require('../../assets/images/troubleshooting.png'),
                          style: {"max-width":"100%","height":"auto"}
                        }, null, 8, _hoisted_56)
                      ])
                    ])
                  ]),
                  (_ctx.usageStats)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            (_ctx.isTrial)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_60, _hoisted_62))
                              : _createCommentVNode("", true),
                            _createVNode(_component_UsageStatBarGraph, {
                              title: "Total Connections",
                              subTitle: "How many times users connected a device with Ditto.",
                              height: "300",
                              width: "100%",
                              dataPointStyle: [{label:'Total Connections', backgroundColor:'rgba(0, 168, 135,0.65)', borderColor:'rgba(0, 168, 135,1)'}],
                              data: _ctx.totalConnectionsData,
                              groupBy: "week",
                              loading: _ctx.totalConnectionsLoading,
                              enableSumLabel: false,
                              trialMode: _ctx.isTrial
                            }, null, 8, ["dataPointStyle", "data", "loading", "trialMode"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            (_ctx.isTrial)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_65, _hoisted_67))
                              : _createCommentVNode("", true),
                            _createVNode(_component_UsageStatBarGraph, {
                              title: "Total Mirroring Time",
                              subTitle: "The total amount of time all users spent screen mirroring.",
                              height: "300",
                              width: "100%",
                              dataPointStyle: [{label:'Total Mirroring Time', backgroundColor:'rgba(0, 168, 135,0.75)', borderColor:'rgba(0, 168, 135,1)'}],
                              data: _ctx.totalTimeMirroringData,
                              groupBy: "week",
                              loading: _ctx.totalTimeMirroringLoading,
                              enableSumLabel: false,
                              durationType: "seconds",
                              trialMode: _ctx.isTrial
                            }, null, 8, ["dataPointStyle", "data", "loading", "trialMode"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _hoisted_73,
                        _createVNode(_component_SubscriptionStatusProgress, {
                          dashboardMode: true,
                          class: "subscription-status flex-grow-1"
                        }),
                        (_ctx.windowWidth.value < 992)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                              (_ctx.isSystemRole)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "primary",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push({ path: '/receivers/' }))),
                                    class: "mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Add Receivers")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.isTrial)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_75, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.subscriptionStatus ? _ctx.subscriptionStatus.subscriptionAvailability : 0) + " subscribed receiver" + _toDisplayString(_ctx.subscriptionStatus && _ctx.subscriptionStatus.subscriptionAvailability == 1 ? "" : "s"), 1),
                                    _createTextVNode(" remaining")
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_76, [
                              (_ctx.isSystemRole)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "primary",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push({ path: '/receivers/' })))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Add Receivers")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.isTrial)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_77, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.subscriptionStatus ? _ctx.subscriptionStatus.subscriptionAvailability : 0) + " subscribed receiver" + _toDisplayString(_ctx.subscriptionStatus && _ctx.subscriptionStatus.subscriptionAvailability == 1 ? "" : "s"), 1),
                                    _createTextVNode(" remaining")
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.isTrial ? "Your trial is active. Use Ditto free for 30 days." : "Your account is active and paid."), 1),
                        (_ctx.windowWidth.value < 992)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                              _createElementVNode("table", _hoisted_83, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", _hoisted_84, [
                                    _hoisted_85,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.accountStatus) + " " + _toDisplayString(!_ctx.isTrial ? "Billing" : ""), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_86, [
                                    _hoisted_87,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.tierName), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_88, [
                                    _hoisted_89,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.orgUserUsage), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_90, [
                                    _hoisted_91,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.orgReceiverUsage), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_92, [
                                    _hoisted_93,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.orgStorageUsage), 1)
                                  ])
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("table", _hoisted_94, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", _hoisted_95, [
                                  _hoisted_96,
                                  _createElementVNode("td", _hoisted_97, _toDisplayString(_ctx.accountStatus) + " " + _toDisplayString(!_ctx.isTrial ? "Billing" : ""), 1),
                                  _hoisted_98,
                                  _createElementVNode("td", _hoisted_99, _toDisplayString(_ctx.tierName), 1)
                                ]),
                                _hoisted_100,
                                _createElementVNode("tr", _hoisted_101, [
                                  _hoisted_102,
                                  _createElementVNode("td", _hoisted_103, _toDisplayString(_ctx.orgUserUsage), 1),
                                  _hoisted_104,
                                  _createElementVNode("td", _hoisted_105, _toDisplayString(_ctx.orgStorageUsage), 1)
                                ]),
                                _createElementVNode("tr", _hoisted_106, [
                                  _hoisted_107,
                                  _createElementVNode("td", _hoisted_108, _toDisplayString(_ctx.orgReceiverUsage), 1),
                                  _hoisted_109,
                                  _hoisted_110
                                ])
                              ])
                            ])),
                        _hoisted_111,
                        (_ctx.windowWidth.value < 992)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                              (_ctx.hasBillingAccess)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: '/organization/billing',
                                    class: "mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, { type: "primary" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Go to Billing")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.isTrial && _ctx.isSubscriptionActive)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_113, [
                                    _createTextVNode("Your subscription renews on "),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.renewalDate), 1)
                                  ]))
                                : (_ctx.isSubscriptionActive)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_114, [
                                      _createTextVNode("Your trial expires on "),
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.expirationDate), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                              (_ctx.hasBillingAccess)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: '/organization/billing'
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, { type: "primary" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Go to Billing")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.isTrial && _ctx.isSubscriptionActive)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_116, [
                                    _createTextVNode("Your subscription renews on "),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.renewalDate), 1)
                                  ]))
                                : (_ctx.isSubscriptionActive)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_117, [
                                      _createTextVNode("Your trial expires on "),
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.expirationDate), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("div", _hoisted_120, [
                        _createElementVNode("div", null, [
                          _hoisted_121,
                          _hoisted_122,
                          _createElementVNode("div", _hoisted_123, [
                            _createElementVNode("a", _hoisted_124, [
                              _createVNode(_component_el_button, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Learn More")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("img", {
                          class: "dashboard-help-image",
                          src: require('../../assets/images/customization.png'),
                          alt: ""
                        }, null, 8, _hoisted_125)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_126, [
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("div", null, [
                          _hoisted_128,
                          _hoisted_129,
                          _createElementVNode("div", _hoisted_130, [
                            _createElementVNode("div", null, [
                              _createElementVNode("a", _hoisted_131, [
                                _createVNode(_component_el_button, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("See All Topics")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_132, [
                              _createElementVNode("a", _hoisted_133, [
                                _createVNode(_component_el_button, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Open Support Ticket")
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("img", {
                          class: "dashboard-help-image",
                          src: require('../../assets/images/troubleshooting.png')
                        }, null, 8, _hoisted_134)
                      ])
                    ])
                  ]),
                  (_ctx.usageStats)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                        _createElementVNode("div", _hoisted_136, [
                          _createElementVNode("div", _hoisted_137, [
                            (_ctx.isTrial)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_138, _hoisted_140))
                              : _createCommentVNode("", true),
                            _createVNode(_component_UsageStatBarGraph, {
                              title: "Total Connections",
                              subTitle: "How many times users connected a device with Ditto.",
                              height: "400",
                              width: "400",
                              dataPointStyle: [{label:'Total Connections', backgroundColor:'rgba(0, 168, 135,0.65)', borderColor:'rgba(0, 168, 135,1)'}],
                              data: _ctx.totalConnectionsData,
                              groupBy: "week",
                              loading: _ctx.totalConnectionsLoading,
                              enableSumLabel: false,
                              trialMode: _ctx.isTrial
                            }, null, 8, ["dataPointStyle", "data", "loading", "trialMode"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_141, [
                          _createElementVNode("div", _hoisted_142, [
                            (_ctx.isTrial)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_143, _hoisted_145))
                              : _createCommentVNode("", true),
                            _createVNode(_component_UsageStatBarGraph, {
                              title: "Total Mirroring Time",
                              subTitle: "The total amount of time all users spent screen mirroring.",
                              height: "400",
                              width: "400",
                              dataPointStyle: [{label:'Total Mirroring Time', backgroundColor:'rgba(0, 168, 135,0.75)', borderColor:'rgba(0, 168, 135,1)'}],
                              data: _ctx.totalTimeMirroringData,
                              groupBy: "week",
                              loading: _ctx.totalTimeMirroringLoading,
                              enableSumLabel: false,
                              durationType: "seconds",
                              trialMode: _ctx.isTrial
                            }, null, 8, ["dataPointStyle", "data", "loading", "trialMode"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ]))
  ])), [
    [_directive_loading, !_ctx.me || _ctx.isLoading]
  ])
}